
export interface TweetContent {
  mentions?: string[];
  /**
   * @maxLength 280
   * @nullable
   */
  text?: string | null;
}
